// red. TierBadge — der offizielle Tier-Chip (premium./vip.).
// EINE Quelle für alle Premium/VIP-Badges in der App. Design: lowercase
// Tier-Wort + Koral-Quadrat-Punkt, F.brand (Wortmarken-Schrift), KEIN Gold,
// KEIN Icon — der Chip invertiert gegen das Theme (dunkler Chip auf hell,
// heller Chip auf dunkel). Quelle: „red. Pass"-Mockup (brand/profile-home.html),
// erstmals inline im ProfileScreen-Hero gebaut, hier herausgezogen.
//
// Verwendung:
//   <TierBadge tier="premium" />
//   <TierBadge tier="vip" scale={0.85} />   // dezenter, z. B. neben Listenzeilen
import React from 'react';
import { F, withAlpha } from '../../styles/theme';
import { useTheme } from '../../context/ThemeContext';

const CORAL = '#E4544A';

/**
 * @param {'premium'|'vip'} tier  Tier-Wort (lowercase gerendert).
 * @param {number} [scale=1]      Proportionaler Skalierungsfaktor (Basis 24px-Höhe).
 * @param {object} [style]        zusätzliche Wrapper-Styles.
 */
export default function TierBadge({ tier = 'premium', scale = 1, style }) {
  const { T, isDark } = useTheme();
  if (tier !== 'premium' && tier !== 'vip') return null;

  const chipBg = isDark ? '#EDE7DB' : '#1B1B1E';
  const chipFg = isDark ? '#1B1B1E' : '#EDE7DB';
  const s = (v) => v * scale;

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', flexShrink: 0,
      height: s(24), padding: `0 ${s(10)}px`, borderRadius: s(7),
      background: chipBg, boxShadow: `inset 0 0 0 1px ${withAlpha(T.text, 0.1)}`,
      ...style,
    }}>
      <span style={{
        display: 'inline-flex', alignItems: 'baseline',
        fontFamily: F.brand, fontWeight: 700, fontSize: s(11), lineHeight: 1,
        color: chipFg, letterSpacing: '0.01em', textTransform: 'lowercase',
      }}>
        {tier}
        <span style={{
          display: 'inline-block', width: '0.17em', height: '0.17em',
          borderRadius: '22%', background: CORAL,
          marginLeft: '0.09em', alignSelf: 'flex-end', marginBottom: '0.06em',
        }} />
      </span>
    </span>
  );
}
